module.exports = __webpack_public_path__ + "media/images/stickers/sticker4-028d973772026f32a53142ff5a78c7a7.svg";